import { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";

function Documents() {
  const [documents, setDocuments] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("all");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [docsRes, settingsRes] = await Promise.all([
        axiosInstance.get("/api/documents"),
        axiosInstance.get("/api/settings"),
      ]);
      setDocuments(docsRes.data);
      setSettings(settingsRes.data);
    } catch (err) {
      console.error("Failed to load documents", err);
    } finally {
      setLoading(false);
    }
  };

  const primaryColor = settings?.theme_primary_color || "#0d6efd";

  const categories = [
    "all",
    ...new Set(documents.map((d) => d.category).filter(Boolean)),
  ];
  const filtered =
    activeCategory === "all"
      ? documents
      : documents.filter((d) => d.category === activeCategory);

  const fileIcon = (path) => {
    const ext = path?.split(".").pop()?.toLowerCase();
    if (ext === "pdf") return "bi-file-earmark-pdf text-danger";
    if (["doc", "docx"].includes(ext))
      return "bi-file-earmark-word text-primary";
    if (["xls", "xlsx"].includes(ext))
      return "bi-file-earmark-excel text-success";
    return "bi-file-earmark text-muted";
  };

  return (
    <div>
      <section
        className="py-4 text-white"
        style={{ backgroundColor: primaryColor }}
      >
        <div className="container">
          <h1 className="fw-bold mb-0">Documents</h1>
          <p className="mb-0 opacity-75">
            Circulars, forms, and downloads from {settings?.school_name}
          </p>
        </div>
      </section>

      <div className="container py-5">
        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : documents.length === 0 ? (
          <p className="text-muted text-center py-5">
            No documents available yet.
          </p>
        ) : (
          <>
            {categories.length > 1 && (
              <div className="d-flex gap-2 mb-4 flex-wrap">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    className={`btn btn-sm ${
                      activeCategory === cat
                        ? "text-white"
                        : "btn-outline-secondary"
                    }`}
                    style={
                      activeCategory === cat
                        ? { backgroundColor: primaryColor }
                        : {}
                    }
                    onClick={() => setActiveCategory(cat)}
                  >
                    {cat === "all" ? "All" : cat}
                  </button>
                ))}
              </div>
            )}

            <div className="card border-0 shadow-sm">
              <div className="list-group list-group-flush">
                {filtered.map((doc) => (
                  <a
                    key={doc.id}
                    href={`${process.env.REACT_APP_API_URL}/${doc.file_path}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="list-group-item list-group-item-action d-flex align-items-center justify-content-between py-3"
                  >
                    <div className="d-flex align-items-center gap-3">
                      <i className={`bi ${fileIcon(doc.file_path)} fs-3`}></i>
                      <div>
                        <div className="fw-medium">{doc.title}</div>
                        {doc.category && (
                          <div className="text-muted small">{doc.category}</div>
                        )}
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      {doc.file_size_kb && (
                        <span className="text-muted small d-none d-sm-inline">
                          {doc.file_size_kb} KB
                        </span>
                      )}
                      <i className="bi bi-download text-muted"></i>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Documents;
